<template>
  <PageHeader></PageHeader>

  <div class="page-wrapper">
    <div class="container">
      <div class="content">
        <!-- Blog Post Title -->
        <h1 class="post-title">{{ post.title }}</h1>

        <!-- Author and Date Info -->
        <div class="post-meta">
          <p>By {{ post.author }} - {{ post.date }}</p>
        </div>

        <!-- Blog Image -->
        <img :src="post.image" :alt="post.imageDescription" class="post-image">

        <!-- Blog Content -->
        <div class="post-content" v-html="post.content"></div>

        <!-- Social Links -->
        <div class="social-links">
          <h3>Connect with me:</h3>
          <div class="icons">
            <a href="https://www.linkedin.com/in/jerschwartz/" target="_blank">
              <font-awesome-icon :icon="['fab', 'linkedin']" />
            </a>
            <a href="https://www.instagram.com/jbot/" target="_blank">
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
          </div>
        </div>

        <!-- Back to Blog Listing Link -->
        <a href="/blog" class="back-link">← Back to Blog Listing</a>
      </div>
    </div>

    <footer class="footer">
      <p>Copyright howtojeremy.com© 2025 All rights reserved</p>
    </footer>
  </div>
</template>


<script>
import PageHeader from './PageHeader.vue';

export default {
  name: 'BlogPost',
  components: {
    PageHeader
  },
    props: {
	id: {
	type: String, // or Number, depending on your use case
	required: true
	}
    },    
  data() {
    return {
      post: {
        
      }
    }
  },
    mounted() {


	console.log("Mounted:",this.id)



  fetch(`/posts/${this.id}.json`)
	   .then(response => response.json())
	    .then(data => {
		console.log("Data",data)
		this.post = data

		fetch(`/posts/${this.id}.html`)
		      .then(response => response.text())
		    .then(data => {
		
			    console.log(data)
			    this.post.content = data
			}
			 )
			 
    // Do something with your data
    });

    }
    
}


/*
//add to mounted
  


  */
</script>

<style scoped>
  .page-wrapper {
  min-height: 100vh;
  background-color: #f3f4f6;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.container {
  max-width: 90vw;
  margin: 0 auto;
}

.content {
  background-color: white;
  border-radius: 1rem;
  padding: 2.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.post-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 1rem;
}

.post-meta {
  margin-bottom: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.post-image {
  width: 50%;
  max-width: 400px;
  object-fit: cover;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}

.post-content {
  color: #374151;
  margin-bottom: 2rem;
  line-height: 1.75;
}

.social-links {
  margin-bottom: 2rem;
}

.social-links h3 {
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.75rem;
}

.icons {
  display: flex;
  gap: 1.5rem;
}

.icons a {
  font-size: 1.5rem;
  color: inherit;
  transition: opacity 0.3s;
}

.icons a:hover {
  opacity: 0.7;
}

.icons a:nth-child(1) {
  color: #2563eb;
}

.icons a:nth-child(2) {
  color: #ec4899;
}

.back-link {
  color: #2563eb;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

.footer {
  text-align: center;
  padding: 1.5rem;
  color: #6b7280;
  margin-top: 2rem;
}
</style>

